import { Page, Text, StyleSheet, View } from "@react-pdf/renderer";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import RelatedObjectsTable from "../../components/RelatedObjectsTable";

const RelatedObjectsPage = ({ id, title, author, createdDate, objects, config }) => {
  const styles = StyleSheet.create({
    page: {
      backgroundColor: "white",
      color: "#303030",
      fontFamily: "Inter",
      fontSize: 9,
      padding: "30px 55px 118px",
    },
    anchor: {
      position: "absolute",
      top: 0,
      left: 0,
    },

    h1: {
      fontSize: 18,
      lineHeight: 1.4,
      fontWeight: 600,
      marginBottom: 16,
    },
  });

  return (
    <Page size="A4" dpi={72} style={styles.page}>
      <View id={id} style={styles.anchor}></View>

      <Header createdDate={createdDate} config={config} />

      <Text style={styles.h1}>{title}</Text>

      <RelatedObjectsTable objects={objects} />

      <Footer createdDate={createdDate} author={author} />
    </Page>
  );
};

export default RelatedObjectsPage;
